import { useState, useEffect, useRef } from 'react';

import { Form, Select, Radio, message, InputNumber, Popover } from 'antd';

import { SelectInputWrapper, ModalWrapper } from './style';

import { specialAdd } from '@/apis/cart';
import useUserStore from '@/store/user';
import Utils from '@/utils/Utils';

const options = [
  '行业分销服务',
  '工业控制/自动化',
  '安防',
  '汽车电子',
  '医疗电子',
  '高校教育',
  '科研院所',
  '测试仪器设备',
  '家用电器',
  '照明显示',
  '通信/数据设备',
  '能源/电力',
  '智能交通',
  '个人消费电子产品',
  '机器人',
  'IOT物联网',
  '无人机',
  '其他',
];

export default function QuotedPrice({ open, product, onCancel }) {
  const [expectPrice, setExpectPrice] = useState(null);
  const [lockWarehouseCode, setLockWarehouseCode] = useState('sz');
  const [purchaseNumber, setPurchaseNumber] = useState(null);
  const [offerIndustry, setOfferIndustry] = useState(null);
  const [isShowNumberTip, setIsShowNumberTip] = useState(false);
  const [numberTipText, setNumberTipText] = useState('');
  const [loading, setLoading] = useState(false);
  const [unit, setUnit] = useState(product?.productUnit);
  const [isOpen, setIsOpen] = useState(false);
  const { userInfo, updateUserInfo } = useUserStore();
  const addBtnRef = useRef(null);

  const selectOptions = [
    {
      value: product?.productUnit,
      label: product?.productUnit,
    },
  ];
  if (product?.productMinEncapsulationUnit) {
    selectOptions.push({
      value: product?.productMinEncapsulationUnit,
      label: product?.productMinEncapsulationUnit,
    });
  }
  useEffect(() => {
    if (open) {
      setExpectPrice(null);
      setPurchaseNumber(null);
      setOfferIndustry(null);
    }
    setIsOpen(open);
  }, [open]);

  const selectAfter = (
    <SelectInputWrapper>
      <Select
        className="w-[60px]"
        value={product?.productUnit}
        options={selectOptions}
        onChange={(e) => changeUnit(e)}
      ></Select>
    </SelectInputWrapper>
  );
  const changeUnit = (e) => {
    setUnit(e);
  };
  const handleOk = () => {
    if (loading) return;
    const { spm, lcsc_vid } = Utils.getButtonParams(addBtnRef.current);
    const obj = {
      productCode: product?.productCode,
      purchaseNumber,
      industry: offerIndustry,
      expectPrice: expectPrice,
      lockWarehouseCode,
      trackZone: product?.track_zone,
      lcscVid: lcsc_vid,
      spm,
    };
    if (unit === product?.productMinEncapsulationUnit) {
      obj.purchaseNumber = obj.purchaseNumber * product?.productMinEncapsulationNumber;
    }
    const checkParams = checkOfferParams(obj);
    if (checkParams) {
      setLoading(true);
      specialAdd(obj)
        .then((res) => {
          if (res.needLogin) {
            Utils.showWindowLogin();
          } else if (res?.code === 200) {
            setIsShowNumberTip(false);
            message.success('加入购物车成功！');
            updateUserInfo({
              ...userInfo,
              cartNum: res.result.cart_contains_count,
            });
            onCancel();
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  // 检测提交报价参数是否合法
  const checkOfferParams = (obj) => {
    if (!obj.expectPrice) {
      message.warning('请输入期望价格！');
      return false;
    }
    if (obj.expectPrice && (Number(obj.expectPrice) <= 0 || Number(obj.expectPrice) > 99999)) {
      message.warning('请输入0~100000之间的期望价格！');
      return false;
    }
    if (obj.expectPrice && isNaN(obj.expectPrice)) {
      message.warning('请输入正确的期望价格！');
      return false;
    }
    if (!obj.purchaseNumber) {
      message.warning('请输入需求数量！');
      return false;
    }
    if (obj.purchaseNumber && (Number(obj.purchaseNumber) <= 0 || Number(obj.purchaseNumber) > 99999999)) {
      message.warning('请输入0~100000000之间的需求数量！');
      return false;
    }
    if (obj.purchaseNumber && isNaN(obj.purchaseNumber)) {
      message.warning('请输入正确的需求数量！');
      return false;
    }
    if (obj.purchaseNumber && Number(obj.purchaseNumber) % Number(product?.productStep) !== 0) {
      message.warning('需求数量必须是' + product?.productStep + '的整数倍！');
      return false;
    }
    if (!obj.lockWarehouseCode) {
      message.warning('请选择锁定仓库');
      return false;
    }
    return true;
  };

  const chanegTip = (value) => {
    let realCount = value;
    let content = '';
    if (unit === product?.productMinEncapsulationUnit) {
      realCount *= product?.productMinEncapsulationNumber;
    }
    if (realCount < product?.specialNumber || realCount < 1 || isNaN(realCount)) {
      content = `最小起订量为${product?.specialNumber}，已为您修正购买数量`;
      realCount = product?.specialNumber;
    }
    if (realCount % product?.productStep !== 0) {
      content = `不符合递增量，已为您修正购买数量`;
      realCount = product?.productStep * Math.ceil(realCount / product?.productStep);
    }
    if (unit === product?.productMinEncapsulationUnit) {
      realCount = Math.ceil(realCount / product?.productMinEncapsulationNumber);
    }
    if (content) {
      setIsShowNumberTip(true);
      setNumberTipText(content);
      setTimeout(() => setIsShowNumberTip(false), 3000);
    }
    setPurchaseNumber(realCount);
  };

  const changeBlur = (e) => {
    chanegTip(e.target.value);
  };

  return (
    <ModalWrapper
      width="633px"
      title="申请报价"
      open={isOpen}
      onCancel={() => onCancel()}
      centered
      footer={false}
      maskClosable={false}
    >
      <Form
        name="basic"
        style={{
          maxWidth: 600,
        }}
        initialValues={{
          remember: true,
        }}
        autoComplete="off"
      >
        <div className="flex justify-between">
          <Form.Item
            label="期望价格"
            name="expectPrice"
            className="w-[264px]"
            rules={[
              {
                required: true,
                message: '请填写期望价格',
              },
            ]}
            labelCol={{ style: { width: '80px' } }}
          >
            <InputNumber
              className="!w-[138px]"
              prefix="￥"
              value={expectPrice}
              maxLength={8}
              controls={false}
              formatter={(value) => `${value}`.replace(/\B(?=(\d)+(?!\d))/g, '')}
              parser={(value) => value.replace(/\B(?=(\d)+(?!\d))/g, '')}
              onChange={(e) => setExpectPrice(e)}
            />
            <span className="ml-[9px] inline-block align-sub text-[14px] text-[#000000]"> / PCS</span>
          </Form.Item>
          <Form.Item
            label="需求数量"
            name="purchaseNumber"
            className="w-[234px]"
            rules={[
              {
                required: true,
                message: '请填写需求数量',
              },
            ]}
            labelCol={{ style: { width: '80px' } }}
          >
            <Popover
              content={numberTipText}
              open={isShowNumberTip}
              getPopupContainer={(triggerNode) => triggerNode.parentNode}
            >
              <InputNumber
                value={purchaseNumber}
                addonAfter={selectAfter}
                maxLength={8}
                allowClear
                controls={false}
                formatter={(value) => (/^\d+$/.test(value) ? value : '')}
                parser={(value) => (/^\d+$/.test(value) ? value : '')}
                onChange={(e) => {
                  setPurchaseNumber(e);
                }}
                onBlur={(e) => changeBlur(e)}
              />
            </Popover>
          </Form.Item>
        </div>
        <Form.Item
          label="锁定仓库"
          name="lockWarehouseCode"
          className=""
          rules={[
            {
              required: true,
              message: '请选择锁定仓库!',
            },
          ]}
          labelCol={{ style: { width: '80px' } }}
        >
          <Radio.Group onChange={(e) => setLockWarehouseCode(e.target.value)} value={lockWarehouseCode}>
            <Radio value="sz">广东仓</Radio>
            <Radio value="js">江苏仓</Radio>
          </Radio.Group>
        </Form.Item>
        <Form.Item label="行业" name="industry" labelCol={{ style: { width: '80px' } }}>
          <Select
            placeholder="请选择"
            onChange={(e) => setOfferIndustry(e)}
            value={offerIndustry}
            showSearch
            optionFilterProp="label"
            options={options.map((item) => ({ label: item, value: item }))}
          />
        </Form.Item>
      </Form>
      <div className="text-right">
        <button
          type="primary"
          className="h-[32px] w-[80px] rounded-[6px] bg-[#0093E6] px-[12px] text-[14px] text-[#FFFFFF] opacity-[0.5] hover:opacity-[1]"
          onClick={handleOk}
          ref={addBtnRef}
          data-spm="iad"
        >
          提交报价
        </button>
      </div>
      <div className="mt-[24px] text-[14px] text-[#55637D]">
        <p className="font-bold text-[#FF4960]">说明：</p>
        <p>1、期望价格提交后，商品将自动加入购物车，报价过程中该商品不能提交订单；</p>
        <p>2、商品将于2分钟内，根据您的报价更新合适的价格，晚上8点至次日早上8点不更新报价；</p>
        <p>3、商城更新后的报价，2小时内有效，请及时提交订单！</p>
      </div>
    </ModalWrapper>
  );
}
